exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toastification-close-icon[data-v-38c639d2],.toastification-title[data-v-38c639d2]{line-height:26px}.toastification-title[data-v-38c639d2]{color:inherit}", ""]);

// exports
